import React, { useEffect, useState } from "react";
import "./Timeline.scss"; // Import the SCSS file
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  MenuItem,
  Alert,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PlayArrow, Visibility } from "@mui/icons-material";
import MicIcon from "@mui/icons-material/Mic";
import IconButton from "@mui/material/IconButton";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import RecordsPagination from "../../pages/doctor-console/Utils/RecordsPagination";
const Timeline = ({ data, abdmData, summary, questions, careContextList }) => {
  const [dataArr, setDataArr] = useState(null);
  console.log("Abdm Data from Timeline Page", abdmData);
  console.log("S3 Data from Timeline Page", data);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAbdmModalOpen, setIsAbdmModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null); // Track the selected card
  const [selectedCardAbdm, setSelectedCardAbdm] = useState(null);
  console.log("Data from Timeline Page", data, summary, questions);
  const [isAiEnabled, setIsAiEnabled] = useState(
    sessionStorage.getItem("isAiEnabled") !== undefined &&
      sessionStorage.getItem("isAiEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAiEnabled"))
      : false
  );

  useEffect(() => {
    const reversedData = [...data].reverse();
    setDataArr(reversedData);
  }, [data]);

  const formatCareContextDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    const formattedDateTimeForSpeech = `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return {
      dateForDisplay: formattedDateTime,
      dateForSpeech: formattedDateTimeForSpeech,
    };
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleCloseAbdmModal = () => {
    setIsAbdmModalOpen(false);
  };

  // Rest of your code...

  // Function to handle card click and open the modal with card content
  const handleCardClick = (index) => {
    setSelectedCard(dataArr[index]);
    console.log("Selected Card is", dataArr[index]);
    // console.log("Prescription Details", dataArr[index].prescriptionDetails);
    setIsModalOpen(true);
  };
  const handleCardClickAbdm = (index) => {
    console.log("abdm data of that index", abdmData[index]);
    setSelectedCardAbdm(abdmData[index]);
    setIsAbdmModalOpen(true);
  };
  const handleSpeakClick = (refId) => {
    const careContext = careContextList.find(
      (cc) => cc.care_context_reference === refId
    );
    if (careContext) {
      const { care_context_reference, display, timestamp } = careContext;
      let textToSpeak = "";
      if (timestamp) {
        textToSpeak = `${care_context_reference}. ${display}. Date: ${
          formatCareContextDate(timestamp).dateForSpeech
        }`;
      } else {
        textToSpeak = `${care_context_reference}. ${display}`;
      }

      speakText(textToSpeak);
    }
  };
  const handleSpeakClickAbdm = (refId) => {
    console.log("Ref Id", refId);
    if (refId) {
      let textToSpeak = "";

      textToSpeak = `Visit Puspose id is ${refId}`;

      speakText(textToSpeak);
    }
  };
  const speakText = (text) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    synth.speak(utterance);
  };
  function SummaryComponent() {
    return (
      <Grid
        item
        xs={12}
        style={{
          marginTop: "20px",
          border: "1px solid #21cdc0",
          marginBottom: "10px",
        }}
        className="timeline-card"
      >
        <div>
          <h2 className="console-heading-summary">Summary Of the patient</h2>
        </div>
        <div className="console-data-summary">
          {summary.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      </Grid>
    );
  }
  function QuestionComponent() {
    return (
      <Grid
        item
        xs={12}
        style={{
          marginTop: "20px",
          border: "1px solid #21cdc0",
          marginBottom: "10px",
        }}
        className="timeline-card"
      >
        <div>
          <h2 className="console-heading-summary">Top 3 Questions</h2>
        </div>
        <div className="console-data-summary">
          {questions.length > 0 ? (
            questions.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))
          ) : (
            <div>No data found</div>
          )}
        </div>
      </Grid>
    );
  }

  const getCareContextDisplay = (refId) => {
    const careContext = careContextList.find(
      (cc) => cc.care_context_reference === refId
    );
    return `${careContext.display}`;
  };
  const getCareContextTime = (refId) => {
    const careContext = careContextList.find(
      (cc) => cc.care_context_reference === refId
    );
    return `Date: ${
      formatCareContextDate(careContext.timestamp).dateForDisplay
    }`;
  };
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
            marginBottom: "10px",
            borderRadius: "34px",
            padding: "1rem",
          }}
        >
          <Carousel responsive={responsive}>
            {dataArr !== null &&
            dataArr !== undefined &&
            dataArr.length !== 0 ? (
              dataArr.map((item, index) => (
                <div className="customCardTimeline" key={index}>
                  {/* {index !== dataArr.length - 1 &&
                    shouldRenderRightConnector(index) && (
                      <div className="connector-right"></div>
                    )}

                 
                  {index !== dataArr.length - 1 &&
                    shouldRenderLeftConnector(index) && (
                      <div className="connector-left"></div>
                    )}

                  
                  {index !== dataArr.length - 1 &&
                    shouldRenderDownConnector(index) && (
                      <div className="connector-down"></div>
                    )} */}

                  <div>
                    {/* Card content */}
                    {item !== undefined && (
                      <div className="image-container">
                        <img
                          src="/img/Timeline.jpg"
                          alt="User Photo"
                          height="100"
                          width="100"
                          style={{ margin: "2px auto" }}
                          // className="rounded-photo"
                        />
                        <div className="rounded-box">{index + 1}</div>
                      </div>
                    )}
                    {item !== undefined && (
                      <>
                        <div className="care-context">
                          <div className={`care-context-div `}>
                            <h2 className="console-heading-timeline">
                              {item.care_context}
                            </h2>
                          </div>
                          <div
                            className={`care-context-div`}
                            style={{ marginBottom: "8px" }}
                          >
                            <h2 className="console-heading-timeline">
                              {getCareContextDisplay(item.care_context)}
                            </h2>
                          </div>

                          <div
                            className={`care-context-div console-heading-timeline2`}
                            style={{ marginBottom: "8px" }}
                          >
                            <h2 className="console-heading-timeline2">
                              {getCareContextTime(item.care_context)}
                            </h2>
                          </div>
                        </div>
                        <div className="timeline-card-buttons">
                          <Tooltip title="Speak" arrow placement="top">
                            <IconButton
                              onClick={() =>
                                handleSpeakClick(item.care_context)
                              }
                            >
                              <VolumeUpIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View" arrow placement="top">
                            <IconButton onClick={() => handleCardClick(index)}>
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  marginTop: "20px",
                  padding: "10px",
                  backgroundColor: "#3AC8BA",
                  fontWeight: "bold",
                  fontSize: "25px",
                }}
              >
                No Timeline found!
              </div>
            )}
          </Carousel>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
            marginBottom: "10px",
            borderRadius: "34px",
            padding: "1rem",
          }}
        >
          <Carousel responsive={responsive}>
            {abdmData !== null &&
            abdmData !== undefined &&
            abdmData.length != 0 ? (
              abdmData.map((item, index) => (
                <div className="customCardTimelineAbdm" key={index}>
                  {/* {index !== dataArr.length - 1 &&
                    shouldRenderRightConnector(index) && (
                      <div className="connector-right"></div>
                    )}

                 
                  {index !== dataArr.length - 1 &&
                    shouldRenderLeftConnector(index) && (
                      <div className="connector-left"></div>
                    )}

                  
                  {index !== dataArr.length - 1 &&
                    shouldRenderDownConnector(index) && (
                      <div className="connector-down"></div>
                    )} */}

                  <div>
                    {/* Card content */}
                    {item !== undefined && (
                      <div className="image-container">
                        <img
                          src="/img/Timeline.jpg"
                          alt="User Photo"
                          height="100"
                          width="100"
                          style={{ margin: "2px auto" }}
                          // className="rounded-photo"
                        />
                        <div className="rounded-box">{index + 1}</div>
                      </div>
                    )}
                    {item !== undefined && (
                      <>
                        <div className="care-context">
                          <div
                            className={`care-context-div console-heading-timeline`}
                          >
                            <h2 className="console-heading-timeline">
                              {item.careContextReference}
                            </h2>
                          </div>
                          {/* <div
                            className={`care-context-div console-heading-timeline`}
                          >
                            {getCareContextDisplay(item.care_context)}
                          </div> */}

                          {/* <div
                            className={`care-context-div console-heading-timeline`}
                            style={{ marginBottom: "8px" }}
                          >
                            {getCareContextTime(item.care_context)}
                          </div> */}
                        </div>
                        <div className="timeline-card-buttons">
                          <Tooltip title="Speak" arrow placement="top">
                            <IconButton
                              onClick={() =>
                                handleSpeakClickAbdm(item.careContextReference)
                              }
                            >
                              <VolumeUpIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View" arrow placement="top">
                            <IconButton
                              onClick={() => handleCardClickAbdm(index)}
                            >
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  marginTop: "20px",
                  padding: "10px",
                  backgroundColor: "#3AC8BA",
                  fontWeight: "bold",
                  fontSize: "25px",
                }}
              >
                No Timeline found!
              </div>
            )}
          </Carousel>
        </Grid>
        {isAiEnabled && SummaryComponent()}
        {isAiEnabled && QuestionComponent()}
      </Grid>
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box className="modal-box">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </div>

          {selectedCard !== null && selectedCard["fhir_data"].length !== 0 ? (
            (() => {
              const flattenedRecords = selectedCard["fhir_data"].flatMap(
                (dateObject) =>
                  Object.entries(dateObject).flatMap(([date, items]) =>
                    items.flatMap((item) =>
                      Object.entries(item).map(
                        ([sectionName, sectionData]) => ({
                          sectionName,
                          sectionData,
                        })
                      )
                    )
                  )
              );

              return (
                <Accordion
                  key={selectedCard.care_context + "s3"}
                  className="outer-accordion"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`visit-${
                      selectedCard.care_context + "s3"
                    }-content`}
                    id={`visit-${selectedCard.care_context + "s3"}-header`}
                    className="outer-accordion-summary"
                  >
                    <Typography className="accordion-section-title">
                      {selectedCard.visit_detail}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {flattenedRecords.length > 0 ? (
                      <RecordsPagination records={flattenedRecords} />
                    ) : (
                      "No Data Received"
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })()
          ) : (
            <Typography variant="h6">No Past Visit Found</Typography>
          )}
        </Box>
      </Modal>
      <Modal
        open={isAbdmModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={handleCloseAbdmModal}
      >
        <Box className="modal-box">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={handleCloseAbdmModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography
            id="modal-modal-title"
            fontFamily="times-roman"
            variant="h5"
            component="h2"
          >
            {selectedCard !== null && (
              <div className={`console-heading-timeline`}>
                {selectedCard.care_context} (
                {getCareContextDisplay(selectedCard.care_context)})
              </div>
            )}
          </Typography> */}

          {selectedCardAbdm !== null ? (
            (() => {
              const flattenedRecords = selectedCardAbdm["fhir_data"].flatMap(
                (dateObject) =>
                  Object.entries(dateObject).flatMap(([date, items]) =>
                    items.flatMap((item) =>
                      Object.entries(item).map(
                        ([sectionName, sectionData]) => ({
                          sectionName,
                          sectionData,
                        })
                      )
                    )
                  )
              );
              return (
                <Accordion
                  key={selectedCardAbdm.careContextReference + "abdm"}
                  className="outer-accordion"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`visit-${
                      selectedCardAbdm.careContextReference + "abdm"
                    }-content`}
                    id={`visit-${
                      selectedCardAbdm.careContextReference + "abdm"
                    }-header`}
                    className="outer-accordion-summary"
                  >
                    <Typography className="accordion-section-title">
                      {selectedCardAbdm.hipId}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {flattenedRecords.length > 0 ? (
                      <RecordsPagination records={flattenedRecords} />
                    ) : (
                      "No Data Received"
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })()
          ) : (
            <Typography variant="h6">No Details Found</Typography>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default Timeline;
